module.exports = __webpack_public_path__ + "icomoon.92a2f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/spinnaker/fonts/icomoon.svg?jeuj5q
// module id = 2753
// module chunks = 0